import React, { Component } from 'react'
import {Container} from 'react-grid-system'

// STYLES
import styled from 'styled-components'

// HELPERS
import {Section} from '../../shared/helpers'

// COMPONENTS
import Title from '../../components/title/title.component'
import SubTitle from '../../components/subtitle/subtitle.component'
import Button from '../../components/button/button.component'

import Doc1 from '../../assets/docs/Referencias_de_Boas_Praticas.pdf'

export default class Practices extends Component {
  render () {
    const {t, id} = this.props
    return (
      <Section id={id}>
        <Container>
          <Title color={'#2E84C6'} text={t('Boas Práticas')} />
          <SubTitle color={'#5C5A5A'} text={t('B_frase1')} />
          <SubTitle color={'#5C5A5A'} text={t('B_frase2')} className='mt-4' />
          <SubTitle color={'#5C5A5A'} text={t('B_frase3')} className='mt-4' />
          <ButtonAlign>
            <a href={Doc1} target='_black'>
              <Button bgColor={'#2E84C6'} color='#FFF' size='sm' text={t('B_frase4')} />
            </a>
          </ButtonAlign>
        </Container>
      </Section>
    )
  }
}

const ButtonAlign = styled.div`
    text-align: center!important;
    margin-right: auto;
    margin-left: auto;
`



// WEBPACK FOOTER //
// ./src/sections/practices/practices.component.js